import {
  CommentEditState,
  ICommentEditState,
} from '@app/models/CommentEditState'
import { EditorState } from 'draft-js'
import { List, Record } from 'immutable'
import { AssociatedContact, IAssociatedContact } from './AssociatedContact'

export interface IComment {
  readonly author: IAssociatedContact
  readonly creator: string
  readonly dateCreated: number
  readonly dateUpdated: number
  readonly defaultPublic: boolean
  readonly editState?: ICommentEditState
  readonly hasStarred: List<string>
  readonly id: string
  readonly isEdited: boolean
  readonly isEditing: boolean
  readonly isPublic: boolean
  readonly isSaving: boolean
  readonly markup: string
  readonly markupState: EditorState
  readonly owners: List<string>
  readonly parentId: string
  readonly tags: List<string>
}

const CommentRecord = Record({
  author: new AssociatedContact(),
  creator: '',
  dateCreated: 0,
  dateUpdated: 0,
  defaultPublic: false,
  editState: undefined,
  hasStarred: List<string>(),
  id: '',
  isEdited: false,
  isEditing: false,
  isPublic: false,
  isSaving: false,
  markup: '',
  markupState: EditorState.createEmpty(),
  owners: List<string>(),
  parentId: '',
  tags: List<string>(),
})

export class Comment extends CommentRecord implements IComment {
  public static fromJS(initialState?: Partial<IComment>) {
    if (!initialState) {
      return new Comment()
    }
    const { author, editState, hasStarred, owners, tags, ...rest } =
      initialState
    return new Comment({
      author: AssociatedContact.fromJS(author),
      editState: CommentEditState.fromJS(editState),
      hasStarred: List(hasStarred || []),
      owners: List(owners || []),
      tags: List(tags || []),
      ...rest,
    })
  }

  public readonly author: AssociatedContact
  public readonly creator: string
  public readonly dateCreated: number
  public readonly dateUpdated: number
  public readonly defaultPublic: boolean
  public readonly editState?: CommentEditState
  public readonly hasStarred: List<string>
  public readonly id: string
  public readonly isEdited: boolean
  public readonly isEditing: boolean
  public readonly isPublic: boolean
  public readonly isSaving: boolean
  public readonly markup: string
  public readonly markupState: EditorState
  public readonly owners: List<string>
  public readonly parentId: string
  public readonly tags: List<string>

  constructor(initialState?: Partial<Comment>) {
    initialState ? super(initialState) : super()
  }
}
